import FileSaver from 'file-saver'

export const download = (url, fileName) => {
  FileSaver.saveAs(url, fileName)
}
